var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMenuAplicaciones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_menu_aplicaciones",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4074",
    "data-name": "Grupo 4074",
    transform: "translate(-8 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2358",
    "data-name": "Rect\\xE1ngulo 2358",
    width: 4,
    height: 4,
    transform: "translate(10 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2359",
    "data-name": "Rect\\xE1ngulo 2359",
    width: 4,
    height: 4,
    transform: "translate(18 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2360",
    "data-name": "Rect\\xE1ngulo 2360",
    width: 4,
    height: 4,
    transform: "translate(26 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2967",
    "data-name": "Rect\\xE1ngulo 2967",
    width: 24,
    height: 24,
    transform: "translate(8 11)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4075",
    "data-name": "Grupo 4075",
    transform: "translate(-8 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2358-2",
    "data-name": "Rect\\xE1ngulo 2358",
    width: 4,
    height: 4,
    transform: "translate(10 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2359-2",
    "data-name": "Rect\\xE1ngulo 2359",
    width: 4,
    height: 4,
    transform: "translate(18 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2360-2",
    "data-name": "Rect\\xE1ngulo 2360",
    width: 4,
    height: 4,
    transform: "translate(26 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2410",
    "data-name": "Rect\\xE1ngulo 2410",
    width: 4,
    height: 4,
    transform: "translate(18 13)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4076",
    "data-name": "Grupo 4076",
    transform: "translate(-8 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2358-3",
    "data-name": "Rect\\xE1ngulo 2358",
    width: 4,
    height: 4,
    transform: "translate(10 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2359-3",
    "data-name": "Rect\\xE1ngulo 2359",
    width: 4,
    height: 4,
    transform: "translate(18 13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2360-3",
    "data-name": "Rect\\xE1ngulo 2360",
    width: 4,
    height: 4,
    transform: "translate(26 13)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuAplicaciones);
export default __webpack_public_path__ + "static/media/ic_menu_aplicaciones.c9acc5019615e65dbeff7d2cc27894e9.svg";
export { ForwardRef as ReactComponent };